import { CheckCircle } from "lucide-react";

const RegistrationPending = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md text-center">
        <div className="flex justify-center mb-4">
          <CheckCircle className="text-green-500 w-16 h-16" />
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          Account Registered Successfully
        </h1>
        <p className="text-gray-600 mb-6">
          Your account has been created and is currently waiting for admin approval.
          You will receive an email once your account is activated.
        </p>
      </div>
      <p className="text-gray-400 text-sm mt-6">
        Need help?{" "}
        <a href="mailto:admin@eyeonhealthwellness.com" className="text-blue-500 hover:underline">
          Contact Support
        </a>
      </p>
    </div>
  );
};

export default RegistrationPending;
